(() => {
  const getPage = (element) => element.closest('.bnb-collection-page');

  const normalizeLabel = (value) => value
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const getDesktopFilterLabel = (details) => {
    const label = details.querySelector('.facets__summary-label');
    return normalizeLabel(label ? label.textContent : '');
  };

  const getMobileFilterLabel = (details) => {
    const label = details.querySelector(':scope > .mobile-facets__summary span:first-child');
    return normalizeLabel(label ? label.textContent : '');
  };

  const dedupeFilterGroup = (items, getLabel) => {
    const seen = new Map();

    items.forEach((item) => {
      item.hidden = false;
      const label = getLabel(item);
      if (!label) return;

      if (!seen.has(label)) {
        seen.set(label, item);
        return;
      }

      const keptItem = seen.get(label);
      const keptIsActive = Boolean(keptItem.querySelector('input:checked'));
      const currentIsActive = Boolean(item.querySelector('input:checked'));

      if (currentIsActive && !keptIsActive) {
        keptItem.hidden = true;
        item.hidden = false;
        seen.set(label, item);
      } else {
        item.hidden = true;
      }
    });
  };

  const cleanDuplicateFilters = (root = document) => {
    root.querySelectorAll('.bnb-collection-page #FacetsWrapperDesktop').forEach((wrapper) => {
      dedupeFilterGroup(
        Array.from(wrapper.querySelectorAll(':scope > details.facets__disclosure')),
        getDesktopFilterLabel
      );
    });

    root.querySelectorAll('.bnb-collection-page #FacetsWrapperMobile').forEach((wrapper) => {
      dedupeFilterGroup(
        Array.from(wrapper.querySelectorAll(':scope > details.mobile-facets__details')),
        getMobileFilterLabel
      );
    });
  };

  const openMobileFilters = (button) => {
    const page = getPage(button);
    if (!page) return;

    const drawerDetails = page.querySelector('.mobile-facets__disclosure');
    if (!drawerDetails) return;

    if (!drawerDetails.open) {
      const trigger = drawerDetails.querySelector(':scope > summary');
      if (trigger) trigger.click();
    }

    const targetLabel = (button.dataset.bnbOpenFilter || '').trim().toLowerCase();
    if (!targetLabel) return;

    window.setTimeout(() => {
      const summaries = page.querySelectorAll('.mobile-facets__details:not([hidden]) > summary');
      const aliases = targetLabel === 'size'
        ? ['size', 'age']
        : targetLabel === 'gender'
          ? ['gender', 'boy', 'girl']
          : [targetLabel];
      const target = Array.from(summaries).find((summary) => {
        const text = summary.textContent.trim().toLowerCase();
        return aliases.some((alias) => text.includes(alias));
      });
      if (target && !target.closest('details').open) target.click();
    }, 120);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-bnb-open-filter]');
    if (!button) return;
    event.preventDefault();
    openMobileFilters(button);
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-bnb-sort]');
    if (!select) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url.toString());
  });

  let cleanupFrame = null;
  const queueFilterCleanup = () => {
    if (cleanupFrame) window.cancelAnimationFrame(cleanupFrame);
    cleanupFrame = window.requestAnimationFrame(() => {
      cleanDuplicateFilters();
      cleanupFrame = null;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueFilterCleanup, { once: true });
  } else {
    queueFilterCleanup();
  }

  document.addEventListener('shopify:section:load', queueFilterCleanup);

  const collectionPage = document.querySelector('.bnb-collection-page');
  if (collectionPage) {
    new MutationObserver(queueFilterCleanup).observe(collectionPage, {
      childList: true,
      subtree: true
    });
  }
})();
